<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>

    <div v-if="updateCategoryDetails" class="">
        <div class="">
            <div class="">
                <div class=""></div>
                <div id="details" class="overlay waste_type_pop">
                    <div class="overlay_inner">
                        <div class="row form-modal">
                            <vue-form :state="formstate">
                                <h4 class="text-center" v-if="this.rows.wSubCName">
                                    Update {{ this.rows.wSubCName }}
                                </h4>
                                <h4 class="text-center" v-if="!this.rows.wSubCName">Add</h4>

                                <div class="col-sm-12" style="padding-top:15px">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.subCategoryUpdate)">
                                        <input maxlength="25" type="text" id="sub" name="subCategoryUpdate" class="form-control" v-model="category.subCategoryUpdate" placeholder="Sub Category" pattern="^[a-zA-Z][a-zA-Z0-9\s]{0,25}" />
                                        <field-messages name="subCategoryUpdate" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">
                                                Sub Category is a required field
                                            </div>
                                            <div slot="pattern">
                                                Alphabets/Numbers are allowed.
                                            </div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </vue-form>
                            <div class="form-actions">
                                <button class="mr-2 btn gradientbt" type="submit" @click="createWasteSubType" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="!this.rows.wSubCName">
                                    Add
                                </button>
                                <button type="submit" @click="updateSubWasteType" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="this.rows.wSubCName" v-bind:class="'mr-2 btn gradientbt'">
                                    Update
                                </button>
                                <button @click="onClose" v-bind:class="'mr-5  btn btn-default'">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-show="!loading" class="content">
        <div v-if="isAreaTable" class="password-popup">
            <div class="password-popup-width">
                <!-- <h4>{{subcatdetails}}</h4> -->
                <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <validate auto-label class="form-group required-field">
                                <label> Previous Sub-Category </label>
                                <input required class="form-control" type="text" :value="subcatdetails.wSubCName" disabled name="wCName" placeholder="Category" />
                                <!-- <field-messages
                        name="wCName"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">This is required field</div>
                      </field-messages> -->
                            </validate>
                        </div>
                        <div class="col-sm-6">
                            <validate auto-label class="form-group required-field">
                                <label> New Sub-Category </label>
                                <input required v-model="newSubcat" class="form-control" type="text" name="wCName" placeholder="Category" />
                                <h1>{{ newSubcat }}</h1>
                                <!-- <field-messages
                        name="wCName"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">This is required field</div>
                      </field-messages> -->
                            </validate>
                        </div>

                        <!-- <div class="add_del_btn_wrp">
                    <a class="add_btn" @click="addRow">Add Sub-Category</a>
                  </div> -->
                    </div>
                </vue-form>
            </div>
        </div>
        <div class="box sub_boxs">
            <div class="box-body" v-if="$route.params && $route.params._id == '0'">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div id="details" class="row">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-12">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wCName)">
                                    <label>Category</label>
                                    <input maxlength="25" required v-model="wasteType.wCName" class="form-control" type="text" name="wCName" pattern="^[a-zA-Z][a-zA-Z0-9\s]{0,25}" placeholder="Category (Dry, Wet, E-Waste etc.) " />
                                    <field-messages name="wCName" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Category is required field</div>
                                        <div slot="pattern">
                                            Alphabets/Numbers are allowed.
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="sub_category_paddi">
                                <div class="subbox required-field">
                                    <label>Sub-Category</label>
                                </div>
                                <div class="del_btn_rel ">
                                    <div class="del_btn_rel_flex">
                                        <div class="del_btn_rel_inner" v-for="(wSubCNameItem, index) in wasteType.wSubCName" :key="index">
                                            <validate :key="index" auto-label class="form-group required-field" :class="fieldClassName(formstate.wSubCName)">
                                                <input maxlength="25" required pattern="^[a-zA-Z][a-zA-Z0-9\s]{0,25}" type="text" :name="
                              'wasteType.wSubCName[' +
                                index +
                                '][\'wSubCNameItem\']'
                            " class="form-control" v-model="wasteType.wSubCName[index]" placeholder="Sub-Category (Paper, Plastic, Metal etc.)" />
                                                <field-messages :name="
                              'wasteType.wSubCName[' +
                                index +
                                '][\'wSubCNameItem\']'
                            " show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">
                                                        Sub Category is required field
                                                    </div>
                                                    <div slot="pattern">
                                                        Alphabets/Numbers are allowed.
                                                    </div>
                                                </field-messages>
                                                <!-- <div v-if="wasteType.wSubCName[index] == ''" class="input-error">Please enter a value.</div> -->
                                            </validate>

                                            <div class="add_del_btn_wrp">
                                                <button v-show="wasteType.wSubCName.length > 1" class="del_btn del_btn_wrp" @click="deleteRow(index)">
                                                    -
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="add_del_btn_wrp">
                                    <button class="mr-2 btn gradientbt" type="submit" @click="addRow" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id == '0'">
                                        Add Sub-Category
                                    </button>
                                </div>
                            </div>
                        </div>
                    </vue-form>
                    <div class="col-sm-12 text-right">
                        <router-link :to="{ name: 'wasteType' }">
                            <button class="mr-5 btn btn-default" type="button">
                                Cancel
                            </button>
                        </router-link>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createWasteType" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id == '0'">
                            Add Waste Type
                        </button>
                        <button class="btn gradientbt mr-5" type="submit" @click="updateWasteType1" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id && $route.params._id != '0'">
                            Update Waste Type
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <div v-if="$route.params._id != '0' && !noRecords">
                    <div class="large-12 columns subcattable">
                        <table class="test-table">
                            <tr>
                                <th>Serial No</th>
                                <th>Name</th>
                                <th>Action</th>
                            </tr>
                            <tr v-for="(subcat, index) in wasteType.subCategory" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ subcat.wSubCName }}</td>
                                <td>
                                    <button class="button edit_del_btn">
                                        <i class="fa fa-pencil-square-o" @click="editSubCategory(index, subcat)"></i>
                                    </button>
                                    <button class="button edit_del_btn">
                                        <i class="fa fa-trash-o" @click="deleteSubCat(subcat)"></i>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <button v-if="$route.params._id != '0'" class="text-right add_subcategory" @click="addSubCategory()">
                    Add Sub-Category
                </button>
            </div>

            <div v-if="$route.params._id != '0' && noRecords">
                <h6>No matching records</h6>
            </div>
            <!-- <button class="text-right add_subcategory" @click="addSubCategory()">
                Add Sub-Category
            </button> -->
        </div>
    </div>
</section>
</template>

<script>
import store from "../../../store";
import {
    formService,
    eventBus,
    wasteTypeService
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";
import swal from "sweetalert2";

export default {
    name: "wasteTypeCreate",
    data() {
        return {
            rows: [],
            category: {},
            updateCategoryDetails: false,
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            isAreaTable: false,
            flashMessage: "",
            subcatdetails: "",
            EVENTS: EVENTS,
            noRecords: false,
            formstate: {},
            newSubcat: "",
            wasteType: {
                wSubCName: [""],
            },
            oldWasteType: {},
            wasteTypeId: [],
            input: "",
            items: [],
            categoryy: ["Solid Waste", "Liquid Waste", "E-Waste"],
            subCategoryType: {},
            updateCheckSubCategory: null,
            subcatPayload: {},
        };
    },

    methods: {
        fieldClassName: formService.fieldClassName,
        onClose() {
            this.category.subCategoryUpdate = "";
            this.updateCategoryDetails = false;
        },

        addRow() {
            // this.items.push({});
            this.wasteType.wSubCName.push("");
        },
        deleteRow(index) {
            this.wasteType.wSubCName.splice(index, 1);
        },

        updateWasteType1() {
            for (let i = 0; i < this.wasteType.subCategory.length; i++) {
                let subcatPayload = {};
                subcatPayload["_id"] = this.wasteType.subCategory[i]["_id"];
                subcatPayload["wCId"] = this.wasteType.subCategory[i]["wCId"];
                subcatPayload["wSubCName"] = this.wasteType.wSubCName[i];
                subcatPayload["status"] = this.wasteType.subCategory[i]["status"];
                this.updateWasteSubType(subcatPayload);
            }
            this.updateWasteType();
        },

        editSubCategory(row, subcat) {
            this.rows["_id"] = subcat._id;
            this.rows["wSubCName"] = subcat.wSubCName;
            this.rows["status"] = subcat.status;
            this.rows["wCId"] = subcat.wCId;
            this.updateCategoryDetails = true;
        },
        updateSubWasteType() {
            this.loading = true;
            let updateSubCategorys = {
                _id: this.rows._id,
                wSubCName: this.category.subCategoryUpdate,
                status: this.rows.status,
                wCId: this.rows.wCId,
            };
            return wasteTypeService
                .updateWasteSubType(updateSubCategorys)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The ${this.wasteType.wCName} has been updated successfully.`
                    );
                    this.updateCategoryDetails = false;
                    this.category.subCategoryUpdate = "";
                    this.getWasteType();
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Sub-Category Already Exist!");
                    if (error.data.message.includes("must be one of")) {
                        this.flash = true;
                        this.flashType = "error";
                        this.flashMessage =
                            "That wasteType name is not allowed. You must first update the list of allowed wasteType names" +
                            " in the appy client and server config.";
                    }
                });
        },

        addSubCategory() {
            this.rows.wSubCName = "";
            this.category.subCategoryUpdate = "";
            this.updateCategoryDetails = true;
            this.wasteType._id = this.$route.params._id;
            // swal
            //     .fire({
            //         title: `Add Sub Category`,
            //         html: `
            //     <input type="text" id="add_subCat" class="swal2-input" placeholder="Add Sub Category">`,
            //         confirmButtonText: "Add Subcategory",
            // focusConfirm: false,
            // preConfirm: () => {
            //             const addSubCat = swal.getPopup().querySelector("#add_subCat")
            //                 .value;
            //             return addSubCat;
            //         },
            //     })
            //     .then((result) => {
            //         if (result.value) {
            //             this.createWasteSubType(result, this.wasteType._id);
            //         } else {
            //             swal.close();
            //         }
            //     });
        },

        createWasteSubType(result, id) {
            this.loading = true;
            let subcategory = {};
            subcategory["wSubCName"] = this.category.subCategoryUpdate;
            subcategory["wCId"] = this.wasteType._id;
            return wasteTypeService
                .addwasteSubcategory(subcategory)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The ${subcategory.wSubCName} has been added successfully.`
                    );
                    this.updateCategoryDetails = false;
                    this.category.subCategoryUpdate = "";
                    this.getWasteType();
                })
                .catch((error) => {
                    this.loading = false;
                    this.category.subCategoryUpdate = "";
                    if (error.request.status === 409) {
                        this.$snotify.error("Category Already Exist!");
                    } else {
                        this.$snotify.error("Create Failed!", "Error!");
                    }
                });
        },

        deleteSubCat(subcat) {
            this.subcatdetails = subcat;
            swal({
                title: "Are you sure?",
                text: `Are you sure you want to delete ${this.subcatdetails.wSubCName}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `Yes, Delete!`,
            }).then((result) => {
                if (result.value) {
                    this.deleteSubCategory(this.subcatdetails._id);
                } else {
                    swal.close();
                }
            });
        },

        deleteSubCategory(id) {
            return wasteTypeService
                .deleteSubCategory(id)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The ${this.wasteType.wCName} has been deleted successfully.`
                    );
                    this.getWasteType();
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Update wasteType failed", "Error!");
                    if (error.data.message.includes("must be one of")) {
                        this.flash = true;
                        this.flashType = "error";
                        this.flashMessage =
                            "That wasteType name is not allowed. You must first update the list of allowed wasteType names" +
                            " in the appy client and server config.";
                    }
                });
        },

        updateWasteSubType(subcat, updatedSubCat) {
            // this.updateCheckSubCategory.forEach(element =>{
            //     if(element.wSubCName == updatedSubCat){
            //         this.$snotify.error("Update wasteType Duplicate", "Error!");
            //     }

            // })

            // let resultToReturn = false;
            // resultToReturn = this.updateCheckSubCategory.some((element, index) => {

            //     return this.updateCheckSubCategory.indexOf(element) !== index
            // });

            this.loading = true;
            let subcatPayload = {};
            subcatPayload["_id"] = subcat._id;
            subcatPayload["wSubCName"] = updatedSubCat;
            subcatPayload["status"] = subcat.status;
            subcatPayload["wCId"] = subcat.wCId;
            return wasteTypeService
                .updateWasteSubType(subcatPayload)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The ${this.wasteType.wCName} has been updated successfully.`
                    );
                    this.getWasteType();
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Update wasteType failed", "Error!");
                    if (error.data.message.includes("must be one of")) {
                        this.flash = true;
                        this.flashType = "error";
                        this.flashMessage =
                            "That wasteType name is not allowed. You must first update the list of allowed wasteType names" +
                            " in the appy client and server config.";
                    }
                });
        },

        getWasteType() {
            this.loading = true;
            return wasteTypeService
                .getWasteTypebyId(this.$route.params._id)
                .then((response) => {
                    if (response.data.response.length > 0) {
                        this.noRecords = false;
                        this.wasteType = response.data.response[0];
                        let subCategory = response.data.response[0].subCategory;
                        this.updateCheckSubCategory = response.data.response[0].subCategory;
                    } else {
                        this.noRecords = true;
                    }
                    this.$store.dispatch("setBreadcrumbTitle", this.wasteType.wCName);

                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Update user failed", "Error!");
                });
        },

        createWasteType() {
            let resultToReturn = false;
            resultToReturn = this.wasteType.wSubCName.some((element, index) => {
                return this.wasteType.wSubCName.indexOf(element) !== index;
            });
            if (resultToReturn) {
                this.$snotify.error("Duplicate Sub-Category", "Error!");
            } else {
                this.loading = true;
                return wasteTypeService
                    .addWasteType(this.wasteType)
                    .then((response) => {
                        this.loading = false;
                        this.flash = false;
                        this.$snotify.success(
                            `The ${this.wasteType.wCName} has been added successfully.`
                        );
                        this.$router.push("/wasteType");
                    })
                    .catch((error) => {
                        this.loading = false;
                        if (error.request.status === 409) {
                            this.$snotify.error("Category Already Exist!");
                        } else {
                            this.$snotify.error("Create Failed!", "Error!");
                        }
                    });
            }
        },

        clearChanges() {
            this.wasteType = _.cloneDeep(this.oldWasteType);
            this.category = _.cloneDeep(this.oldWasteType);
            this.formstate._reset();
        },

        updateWasteType() {
            this.loading = true;
            this.wasteType._id = this.$route.params._id;
            return wasteTypeService
                .updateWasteType(this.wasteType, this.oldWasteType)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.formstate._reset();
                    this.oldWasteType = _.cloneDeep(this.wasteType);
                    this.$snotify.success(
                        `The ${this.wasteType.wCName} has been updated successfully.`
                    );
                    this.$router.push("/wasteType");
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Update wasteType failed", "Error!");
                    if (error.data.message.includes("must be one of")) {
                        this.flash = true;
                        this.flashType = "error";
                        this.flashMessage =
                            "That wasteType name is not allowed. You must first update the list of allowed wasteType names" +
                            " in the appy client and server config.";
                    }
                });
        },
    },

    created() {
        const promises = [];
        this.loading = true;
        // promises.push(this.getWasteType());
        if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getWasteType());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
    },
    beforeDestroy() {},

    fieldClassName: function (field) {
        if (!field) {
            return "";
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return "has-success";
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return "has-danger";
        }
    },

    // computed: {
    //     ...mapState({
    //         user: state => state.auth.user,
    //     })
    // }
};
</script>

<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #3085d6;
    color: white;
}

.add_del_btn_wrp {
    z-index: 1;
}

.del_btn {
    cursor: pointer;
    width: fit-content;
    background: #3085d6;
    color: #fff;
    border: #3085d6;
}

.col-sm-4.del_btn_rel {
    padding-right: 30px;
}

.del_btn svg {
    height: 10px;
    width: 10px;
    cursor: pointer;
}

.add_del_btn_wrp .add_btn {
    background: #3085d6;
    color: #fff;
    border: #3085d6;
    padding: 9px;
    cursor: pointer;
    display: inline-block;
    border-radius: 5px;
}

body {
    background-color: lightgray;
}

table {
    width: 100%;
}

td form {
    margin: 0;
    padding: 0;
}

td form button.button {
    padding: 0.25em;
    margin: 0.25em;
    background: none;
    color: blue;
}

td form button.button:hover {
    background: none;
    color: steelblue;
}

.test-table {
    margin-left: 80px;
}

.del_btn_rel_flex {
    display: flex;
    align-items: flex-start;
    width: 100%;
    flex-wrap: wrap;
}

.del_btn_rel_inner {
    flex: 0 0 31%;
    margin-right: 15px;
    position: relative;
    padding-right: 30px;
}

.del_btn_wrp {
    position: absolute;
    right: 0;
    top: 0;
    padding: 3px 12px;
    border-radius: 5px;
    font-size: 20px;
}

.sub_category_paddi {
    padding: 0px 15px;
    height: calc(100vh - 330px);
    overflow: auto;
    overflow-x: hidden;
}

.sub_category_paddi::-webkit-scrollbar {
    width: 5px;
}

.sub_category_paddi::-webkit-scrollbar-thumb {
    background: #888;
}

.subcattable table {
    margin-left: 0px;
}

.subcattable table td,
.subcattable table th {
    border: 1px solid #f4f4f4;
}

.subcattable table tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}

.subcattable table tr:hover {
    background-color: #5e9cfe29 !important;
}

.edit_del_btn {
    border: 0;
    background-color: transparent;
    color: #3085d6;
}

.subcattable table tr td:last-child {
    width: 200px;
}

.add_subcategory {
    background: #3085d6;
    border: 2px solid #3085d6;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-top: 15px;
}

.sub_boxs {
    box-shadow: none;
}

.toggle_icon {
    --width: 64px;
    --height: calc(var(--width) / 3);
    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: none;
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: absolute;
    top: 10px;
    right: -15px;
}

.toggle_icon svg {
    width: 15px;
    height: 15px;
}

.message {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
    display: inline-block;
}

.input-error {
    color: #dd4b39;
}
</style>



// WEBPACK FOOTER //
// wasteTypeCreate.vue?de674ed6